import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M6 6h2v12H6zm3.5 6l8.5 6V6z" />, 'SkipPrevious');
